<template>
  <div class="mypage-user-init-confirm-page">
    <mypage-user-edit-header-section
      :pageTitle="$tc('MypagePage.MypageUserEditPage.pageTitle')"
      :has-back-link="false"
    />

    <mypage-user-init-confirm-pane
      class="mypage-user-init-confirm-page__content"
      @successRegist="moveToNextPage"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypageUserEditHeaderSection from '@/components/MypageUserEditPage/MypageUserEditPane/MypageUserEditHeaderSection.vue'
import MypageUserInitConfirmPane from '@/components/MypageUserInitConfirmPage/MypageUserInitConfirmPane.vue'
import UserStore from '@/store/stores/pageStore/common/UserStore'

/**
 * マイページ: 初期会員情報確認ページ
 */
export default defineComponent({
  name: 'MypageUserInitConfirmPage',
  components: {
    MypageUserEditHeaderSection,
    MypageUserInitConfirmPane,
  },
  methods: {
    /**
     * 会員情報登録
     * @event registration
     */
    moveToNextPage() {
      if (UserStore.value.ownBillingInfo.value?.isAccountPending) {
        // 決済未完了状態であれば強制的にマイページに遷移させる
        this.$router.replace({ name: 'MypageTopPage' })
        return
      }

      // TOP画面に遷移
      this.$router.replace({ name: 'TopPage' })
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-user-init-confirm-page {
  padding-bottom: 154px;
}
</style>
